import { render, staticRenderFns } from "./identifying-hair-types.vue?vue&type=template&id=b0e70aca&scoped=true&"
import script from "./identifying-hair-types.vue?vue&type=script&lang=js&"
export * from "./identifying-hair-types.vue?vue&type=script&lang=js&"
import style0 from "./identifying-hair-types.vue?vue&type=style&index=0&id=b0e70aca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e70aca",
  null
  
)

export default component.exports